import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, filter } from 'rxjs';

import { ChatAdminUnreadCountUpdatedPayload } from '../models/chat';
import { AdminChatService } from './admin-chat.service';
import { ChatSocketService } from './chat-socket.service';

@Injectable({
  providedIn: 'root'
})
export class ChatUnreadSessionService {
  private readonly unreadCountSubject = new BehaviorSubject<number>(0);
  private subscriptions = new Subscription();
  private active = false;

  readonly unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(
    private chatService: AdminChatService,
    private chatSocket: ChatSocketService
  ) {}

  public start(): void {
    if (this.active) {
      return;
    }

    this.active = true;
    this.subscriptions.add(
      this.chatSocket.eventsOfType<ChatAdminUnreadCountUpdatedPayload>('admin_unread_count.updated')
        .subscribe((event) => this.unreadCountSubject.next(event.payload.total_unread))
    );
    this.subscriptions.add(
      this.chatSocket.connectionState$
        .pipe(filter((state) => state === 'open'))
        .subscribe(() => this.refreshUnreadCount())
    );

    this.refreshUnreadCount();
    this.chatSocket.connect();
  }

  public stop(): void {
    if (!this.active) {
      return;
    }

    this.active = false;
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
    this.unreadCountSubject.next(0);
    this.chatSocket.disconnect();
  }

  private refreshUnreadCount(): void {
    if (!this.active) {
      return;
    }

    this.chatService.obtenerTotalNoLeidos().subscribe({
      next: (response) => {
        if (this.active) {
          this.unreadCountSubject.next(response.total_unread);
        }
      },
      error: () => undefined
    });
  }
}
